{
  "loading": "Učitavam...",
  "loadingMore": "Učitavam još..."
}